{
  "schemaVersion": "1.0",
  "status": "DRAFT_DIRECTIONAL",
  "note": "Directional marketing content. Prices are management targets; public-pricing.json must be generated from Pricing Master at publish.",
  "moduleId": "shop",
  "worksWith": [
    {
      "type": "INCLUDES",
      "target": "intelligence",
      "label": "Includes Intelligence"
    },
    {
      "type": "OPTIONAL_WITH",
      "target": "vault",
      "label": "Vault optional for permanent tail records"
    },
    {
      "type": "COORDINATES_WITH",
      "target": "operate",
      "label": "Work coordination & handoff"
    }
  ]
}